// Best-effort JSON extraction from a model reply. Neither WebLLM's quantised
// builds nor Gemini reliably emit a bare JSON object every time — replies may
// be wrapped in a ```json fence or surrounded by prose. A plain JSON.parse
// then throws, the output-validator rejects, and the editor sees a silent
// "no enrichment". Trying harder here recovers the common cases without
// weakening schema validation (the extracted value still goes through the
// output-validator downstream).
export function extractJson(raw: string): unknown {
  const t = raw.trim();
  try {
    return JSON.parse(t);
  } catch {
    /* fall through */
  }
  const fence = t.match(/```(?:json)?\s*([\s\S]*?)\s*```/i);
  if (fence) {
    try {
      return JSON.parse(fence[1].trim());
    } catch {
      /* fall through */
    }
  }
  const start = t.search(/[{[]/);
  const end = Math.max(t.lastIndexOf('}'), t.lastIndexOf(']'));
  if (start !== -1 && end > start) {
    try {
      return JSON.parse(t.slice(start, end + 1));
    } catch {
      /* fall through */
    }
  }
  return undefined;
}
